import {
    IS_LOADING_ACTIVE_PERMISSION_LIST,ACTIVE_PERMISSION_LIST,DELETE_PERMISSION,GET_PERMISSION_INFO,IS_LOADING_INACTIVE_PERMISSION_LIST,INACTIVE_PERMISSION_LIST
    ,CHANGE_TO_ACTIVE_PERMISSION,CHANGE_TO_INACTIVE_PERMISSION,IS_LOADING_ACTIVE_TYPE_MANAGER_LIST,ACTIVE_TYPE_MANAGER_LIST,IS_LOADING_INACTIVE_TYPE_MANAGER_LIST,INACTIVE_TYPE_MANAGER_LIST,
    DELETE_TYPE_MANAGER,GET_TYPE_MANAGER_INFO,CHANGE_TO_ACTIVE_TYPE_MANAGER,CHANGE_TO_INACTIVE_TYPE_MANAGER,CREATE_TYPE_MANAGER,EDIT_TYPE_MANAGER,CREATE_PERMISSION,EDIT_PERMISSION,
    IS_LOADING_PERMISSION_LIST_ADMIN,PERMISSION_LIST_ADMIN,CREATE_PERMISSION_ADMIN,EDIT_PERMISSION_ADMIN,DELETE_PERMISSION_ADMIN,IS_LOADING_ROLES_LIST_ADMIN,
    ROLE_LIST_ADMIN,CREATE_ROLE_ADMIN,EDIT_ROLE_ADMIN,GET_ROLE_INFO,DELETE_ROLE_ADMIN,IS_LOADING_LIST_ADMIN,LIST_ADMIN,CREATE_ADMIN,EDIT_ADMIN,GET_ADMIN_INFO,DELETE_ADMIN,IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST,ACTIVE_PROFESSIONAL_PERMISSION_LIST,IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST,
    CREATE_PROFESSIONAL_PERMISSION,EDIT_PROFESSIONAL_PERMISSION,INACTIVE_PROFESSIONAL_PERMISSION_LIST,DELETE_PROFESSIONAL_PERMISSION,CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION,CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION,
    GET_PROFESSIONAL_PERMISSION_INFO,ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,CREATE_ROLE_PROFESSIONAL_COMMUNITY,EDIT_ROLE_PROFESSIONAL_COMMUNITY,IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
    INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,DELETE_ROLE_PROFESSIONAL_COMMUNITY,GET_ROLE_PROFESSIONAL_COMMUNITY_INFO,CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY,CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY,IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST, GET_MY_ADMIN_INFO
} from '../actions/types'
    
    const initialState = {

        isLoadinglistActivePermission:false,
        listActivePermission:[],
        isLoadinglistInactivePermission:false,
        listInactivePermission:[],
        roleInfo:null,
        adminMyInfo:null,
        permissionInfo:{},
        listActiveTypeManager:[],
        isLoadinglistActiveTypeManager:false,
        isLoadinglistInactiveTypeManager:false,
        listActiveTypeManager:[],
        listInactiveTypeManager:[],
        typeManagerInfo:{},
        isLoadinglistPermissionAdmin:false,
        listPermissionAdmin:[],
        isLoadinglistRoleAdmin:false,
        listRoleAdmin:[],
        isLoadingListAdmin:false,
        listAdmin:[],
        adminInfo:{},
        isLoadinglistActiveProfessionalPermission:false,
        listActiveProfessionalPermission:[],
        isLoadinglistInactiveProfessionalPermission:false,
        isLoadinglistActiveRoleProfessionalCommunity:false,
        listActiveRoleProfessionalCommunity:[],
        isLoadinglistInactiveRoleProfessionalCommunity:false,
        listInactiveRoleProfessionalCommunity:[]

        
    }
    
    export default function (state = initialState, action) {
        switch (action.type) {

        case IS_LOADING_ACTIVE_PERMISSION_LIST:
            return { ...state, isLoadinglistActivePermission:true}
        case ACTIVE_PERMISSION_LIST:
            return { ...state, listActivePermission:action.payload, isLoadinglistActivePermission:false}
        case IS_LOADING_INACTIVE_PERMISSION_LIST:
            return { ...state, isLoadinglistInactivePermission:true}
        case CREATE_PERMISSION:
            var addPermission = Array.from(state.listActivePermission)
            addPermission.push(action.payload)
            return { ...state, listActivePermission: addPermission, isLoadinglistActivePermission: false } 
        case EDIT_PERMISSION:
            console.log()
            var editPermission= Array.from(state.listActivePermission)
            editPermission[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listActivePermission: editPermission, isLoadinglistActivePermission: false }
        case INACTIVE_PERMISSION_LIST:
            return { ...state, listInactivePermission:action.payload, isLoadinglistInactivePermission:false}
        case DELETE_PERMISSION:
            if(action.payload.fromWhere==='activePermissions'){
            var deleteActivePermission = Array.from(state.listActivePermission)
            deleteActivePermission.splice(action.payload.index, 1)
            return { ...state, isLoadinglistActivePermission:false, listActivePermission: deleteActivePermission}}
            if(action.payload.fromWhere==='inactivePermissions'){
            var deleteInactivePermission = state.listInactivePermission
            deleteInactivePermission.splice(action.payload.index, 1)
            return { ...state, isLoadinglistInactivePermission:false, listInactivePermission: deleteInactivePermission}}
        case CHANGE_TO_ACTIVE_PERMISSION:
            var  getInactivePermissionList = state.listInactivePermission
            var  getActivePermissionList = Array.from(state.listActivePermission)
            var permissionToMove = getInactivePermissionList[action.payload]
            getActivePermissionList.push(permissionToMove)
            getInactivePermissionList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactivePermission:false,isLoadinglistActivePermission:false,listActivePermission:getActivePermissionList, listInactivePermission: getInactivePermissionList}
        case CHANGE_TO_INACTIVE_PERMISSION:
            var  getInactivePermissionList = state.listInactivePermission
            var  getActivePermissionList = Array.from(state.listActivePermission)
            var permissionToMove = getActivePermissionList[action.payload]
            getInactivePermissionList.push(permissionToMove)
            getActivePermissionList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactivePermission:false,isLoadinglistActivePermission:false,listActivePermission:getActivePermissionList, listInactivePermission: getInactivePermissionList}
        case IS_LOADING_ACTIVE_TYPE_MANAGER_LIST:
            return { ...state, isLoadinglistActiveTypeManager:true}
        case ACTIVE_TYPE_MANAGER_LIST:
            return { ...state, isLoadinglistActiveTypeManager:false,listActiveTypeManager:action.payload}
        case CREATE_TYPE_MANAGER:
            console.log()
            var addTypeManager = state.listActiveTypeManager
            addTypeManager.push(action.payload)
            return { ...state, listActiveTypeManager: addTypeManager, isLoadinglistActiveTypeManager: false } 
        case EDIT_TYPE_MANAGER:
            console.log()
            var editTypeManager = state.listActiveTypeManager
            editTypeManager[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listActiveTypeManager: editTypeManager, isLoadinglistActiveTypeManager: false }
        case IS_LOADING_INACTIVE_TYPE_MANAGER_LIST:
            return { ...state, isLoadinglistInactiveTypeManager:true}
        case INACTIVE_TYPE_MANAGER_LIST:
            return { ...state, isLoadinglistInactiveTypeManager:false,listInactiveTypeManager:action.payload}
        case GET_PERMISSION_INFO:
            return { ...state, permissionInfo:action.payload}
        case DELETE_TYPE_MANAGER:
        if(action.payload.fromWhere==='activeTypeManager'){
            var deleteActiveTypeManager = state.listActiveTypeManager
            deleteActiveTypeManager.splice(action.payload.index, 1)
            return { ...state, isLoadinglistActiveTypeManager:false, listActiveTypeManager: deleteActiveTypeManager}}
            if(action.payload.fromWhere==='inactiveTypeManager'){
            var deleteInactiveTypeManager = state.listInactiveTypeManager
            deleteInactiveTypeManager.splice(action.payload.index, 1)
            return { ...state, isLoadinglistInactiveTypeManager:false, listInactiveTypeManager: deleteInactiveTypeManager}}
        case GET_TYPE_MANAGER_INFO:
            return { ...state, typeManagerInfo:action.payload}
        case CHANGE_TO_ACTIVE_TYPE_MANAGER:
            var  getInactiveTypeManagerList = state.listInactiveTypeManager
            var  getActiveTypeManagerList = state.listActiveTypeManager
            var typeManagerToMove = getInactiveTypeManagerList[action.payload]
            getActiveTypeManagerList.push(typeManagerToMove)
            getInactiveTypeManagerList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveTypeManager:false,isLoadinglistActiveTypeManager:false,listActiveTypeManager:getActiveTypeManagerList, listInactiveTypeManager: getInactiveTypeManagerList}
        case CHANGE_TO_INACTIVE_TYPE_MANAGER:
            var  getInactiveTypeManagerList = state.listInactiveTypeManager
            var  getActiveTypeManagerList = state.listActiveTypeManager
            var typeManagerToMove = getActiveTypeManagerList[action.payload]
            getInactiveTypeManagerList.push(typeManagerToMove)
            getActiveTypeManagerList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveTypeManager:false,isLoadinglistActiveTypeManager:false,listActiveTypeManager:getActiveTypeManagerList, listInactiveTypeManager: getInactiveTypeManagerList}
        
    
        case IS_LOADING_PERMISSION_LIST_ADMIN:
            return { ...state, isLoadinglistPermissionAdmin:true}
        case PERMISSION_LIST_ADMIN:
            return { ...state, listPermissionAdmin:action.payload, isLoadinglistPermissionAdmin:false}
        case CREATE_PERMISSION_ADMIN:
            var addPermission = Array.from(state.listPermissionAdmin)
            addPermission.push(action.payload)
            return { ...state, listPermissionAdmin: addPermission, isLoadinglistPermissionAdmin: false } 
        case EDIT_PERMISSION_ADMIN:
            console.log()
            var editPermission= Array.from(state.listPermissionAdmin)
            editPermission[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listPermissionAdmin: editPermission, isLoadinglistPermissionAdmin: false }  
        case DELETE_PERMISSION_ADMIN:          
            var deleteActivePermission = Array.from(state.listPermissionAdmin)
            deleteActivePermission.splice(action.payload, 1)
            return { ...state, isLoadinglistPermissionAdmin:false, listPermissionAdmin: deleteActivePermission}
    
        case IS_LOADING_ROLES_LIST_ADMIN:
            return { ...state, isLoadinglistRoleAdmin:true}
        case ROLE_LIST_ADMIN:
            return { ...state, isLoadinglistRoleAdmin:false,listRoleAdmin:action.payload}
        case CREATE_ROLE_ADMIN:
            console.log()
            var addRole = state.listRoleAdmin
            addRole.push(action.payload)
            return { ...state, listRoleAdmin: addRole, isLoadinglistRoleAdmin: false } 
        case EDIT_ROLE_ADMIN:
            console.log()
            var editRole = state.listRoleAdmin
            editRole[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listRoleAdmin: editRole, isLoadinglistRoleAdmin: false }
        case GET_ROLE_INFO:
            return { ...state, roleInfo:action.payload}
        case DELETE_ROLE_ADMIN:
            var deleteRole = state.listRoleAdmin
            deleteRole.splice(action.payload, 1)
            return { ...state, isLoadinglistRoleAdmin:false, listRoleAdmin: deleteRole}
        
        
        case IS_LOADING_LIST_ADMIN:
            return { ...state, isLoadingListAdmin:true}
        case LIST_ADMIN:
            return { ...state, isLoadingListAdmin:false,listAdmin:action.payload}
        case CREATE_ADMIN:
            console.log()
            var addAdmin = Array.from(state.listAdmin)
            addAdmin.push(action.payload)
            return { ...state, listAdmin: addAdmin, isLoadingListAdmin: false } 
        case EDIT_ADMIN:
            console.log()
            var editAdmin = Array.from(state.listAdmin)
            editAdmin[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listAdmin: editAdmin, isLoadingListAdmin: false }
        case GET_ADMIN_INFO:
            return { ...state, adminInfo:action.payload}
            case GET_MY_ADMIN_INFO:
                return { ...state, adminMyInfo:action.payload}
        case DELETE_ADMIN:
            var deleteAdmin = Array.from(state.listAdmin)
            deleteAdmin.splice(action.payload, 1)
            return { ...state, isLoadingListAdmin:false, listAdmin: deleteAdmin}
            

    
        case IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST:
            return { ...state, isLoadinglistActiveProfessionalPermission:true}
        case ACTIVE_PROFESSIONAL_PERMISSION_LIST:
            return { ...state, listActiveProfessionalPermission:action.payload, isLoadinglistActiveProfessionalPermission:false}
        case IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST:
            return { ...state, isLoadinglistInactiveProfessionalPermission:true}
        case CREATE_PROFESSIONAL_PERMISSION:
            var addPermission = state.listActiveProfessionalPermission
            addPermission.push(action.payload)
            return { ...state, listActiveProfessionalPermission: addPermission, isLoadinglistActiveProfessionalPermission: false } 
        case EDIT_PROFESSIONAL_PERMISSION:
            console.log()
            var editPermission= state.listActiveProfessionalPermission
            editPermission[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listActiveProfessionalPermission: editPermission, isLoadinglistActiveProfessionalPermission: false }
        case INACTIVE_PROFESSIONAL_PERMISSION_LIST:
            return { ...state, listInactiveProfessionalPermission:action.payload, isLoadinglistInactiveProfessionalPermission:false}
        case DELETE_PROFESSIONAL_PERMISSION:
            if(action.payload.fromWhere==='activePermissions'){
            var deleteActivePermission = state.listActiveProfessionalPermission
            deleteActivePermission.splice(action.payload.index, 1)
            return { ...state, isLoadinglistActiveProfessionalPermission:false, listActiveProfessionalPermission: deleteActivePermission}}
            if(action.payload.fromWhere==='inactivePermissions'){
            var deleteInactivePermission = state.listInactiveProfessionalPermission
            deleteInactivePermission.splice(action.payload.index, 1)
            return { ...state, isLoadinglistInactiveProfessionalPermission:false, listInactiveProfessionalPermission: deleteInactivePermission}}
        case CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION:
            var  getInactivePermissionList = state.listInactiveProfessionalPermission
            var  getActivePermissionList = state.listActiveProfessionalPermission
            var permissionToMove = getInactivePermissionList[action.payload]
            getActivePermissionList.push(permissionToMove)
            getInactivePermissionList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveProfessionalPermission:false,isLoadinglistActiveProfessionalPermission:false,listActiveProfessionalPermission:getActivePermissionList, listInactiveProfessionalPermission: getInactivePermissionList}
        case CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION:
            var  getInactivePermissionList = state.listInactiveProfessionalPermission
            var  getActivePermissionList = state.listActiveProfessionalPermission
            var permissionToMove = getActivePermissionList[action.payload]
            getInactivePermissionList.push(permissionToMove)
            getActivePermissionList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveProfessionalPermission:false,isLoadinglistActiveProfessionalPermission:false,listActiveProfessionalPermission:getActivePermissionList, listInactiveProfessionalPermission: getInactivePermissionList}
        case GET_PROFESSIONAL_PERMISSION_INFO:
            return { ...state, permissionInfo:action.payload}
    

        case IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST:
            return { ...state, isLoadinglistActiveRoleProfessionalCommunity:true}
        case ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST:
            return { ...state, isLoadinglistActiveRoleProfessionalCommunity:false,listActiveRoleProfessionalCommunity:action.payload}
        case CREATE_ROLE_PROFESSIONAL_COMMUNITY:
            console.log()
            var addTypeManager = state.listActiveRoleProfessionalCommunity
            addTypeManager.push(action.payload)
            return { ...state, listActiveRoleProfessionalCommunity: addTypeManager, isLoadinglistActiveRoleProfessionalCommunity: false } 
        case EDIT_ROLE_PROFESSIONAL_COMMUNITY:
            console.log()
            var editTypeManager = state.listActiveRoleProfessionalCommunity
            editTypeManager[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listActiveRoleProfessionalCommunity: editTypeManager, isLoadinglistActiveRoleProfessionalCommunity: false }
        case IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST:
            return { ...state, isLoadinglistInactiveRoleProfessionalCommunity:true}
        case INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST:
            return { ...state, isLoadinglistInactiveRoleProfessionalCommunity:false,listInactiveRoleProfessionalCommunity:action.payload}
        case DELETE_ROLE_PROFESSIONAL_COMMUNITY:
        if(action.payload.fromWhere==='activeRole'){
            var deleteActiveTypeManager = state.listActiveRoleProfessionalCommunity
            deleteActiveTypeManager.splice(action.payload.index, 1)
            return { ...state, isLoadinglistActiveRoleProfessionalCommunity:false, listActiveRoleProfessionalCommunity: deleteActiveTypeManager}}
            if(action.payload.fromWhere==='inactiveRole'){
            var deleteInactiveTypeManager = state.listInactiveRoleProfessionalCommunity
            deleteInactiveTypeManager.splice(action.payload.index, 1)
            return { ...state, isLoadinglistInactiveRoleProfessionalCommunity:false, listInactiveRoleProfessionalCommunity: deleteInactiveTypeManager}}
        case GET_ROLE_PROFESSIONAL_COMMUNITY_INFO:
            return { ...state, typeManagerInfo:action.payload}
        case CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY:
            var  getInactiveTypeManagerList = state.listInactiveRoleProfessionalCommunity
            var  getActiveTypeManagerList = state.listActiveRoleProfessionalCommunity
            var typeManagerToMove = getInactiveTypeManagerList[action.payload]
            getActiveTypeManagerList.push(typeManagerToMove)
            getInactiveTypeManagerList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveRoleProfessionalCommunity:false,isLoadinglistActiveRoleProfessionalCommunity:false,listActiveRoleProfessionalCommunity:getActiveTypeManagerList, listInactiveRoleProfessionalCommunity: getInactiveTypeManagerList}
        case CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY:
            var  getInactiveTypeManagerList = state.listInactiveRoleProfessionalCommunity
            var  getActiveTypeManagerList = state.listActiveRoleProfessionalCommunity
            var typeManagerToMove = getActiveTypeManagerList[action.payload]
            getInactiveTypeManagerList.push(typeManagerToMove)
            getActiveTypeManagerList.splice(action.payload, 1)
            return { ...state, isLoadinglistInactiveRoleProfessionalCommunity:false,isLoadinglistActiveRoleProfessionalCommunity:false,listActiveRoleProfessionalCommunity:getActiveTypeManagerList, listInactiveRoleProfessionalCommunity: getInactiveTypeManagerList}
    

    


        default:
        return state
        
        }
    }